const style = '4px dashed #f00'
export const focusStyle = {
	'&:focus-visible, &.Mui-focusVisible': {
		outline: style,
		outlineOffset: '5px'
	}
}

export const focusStyleBorder = {
	'&:focus-visible, &.Mui-focusVisible': {
		outline: 'none',
		border: style,
		borderOffset: '5px'
	}
}

export const headingStyle = {
	position: 'relative',
	height: '4rem',
	marginBottom: '1rem'
}

export const wrapperStyle = {
	marginBottom: '2rem'
}

export const pageContainerStyle = {
	'.opsot-layout-inner-container': {
		paddingTop: { xs: '1rem', md: '3.5rem' },
		paddingBottom: { xs: '4rem', md: '7.5rem' }
	},
	' a': {
		...focusStyle
	}
}

export const spanStyles = {
	display: 'block',
	marginBlockStart: '1em',
	marginBlockEnd: '1em',
	marginInlineStart: '0px',
	marginInlineEnd: '0px',
	unicodeBidi: 'isolate'
}
